import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../hooks/store';
import LangSwitcher from '../components/search/LangSwitcher';
import About from '../modal/About';
import SwitchToProfile from '../components/search/SwitchToProfile';
import AttendeeList from '../components/search/AttendeeList';
import CategoryList from '../components/search/CategoryList';
import { Category } from '../types';
import getFileURL from '../utils/getFileURL';
import './Search.css';

export interface SearchProps {
	refSearch: React.RefObject<HTMLDivElement>,
    refProfile: React.RefObject<HTMLDivElement>,
};

const Search: FC<SearchProps> = ({ refSearch, refProfile }) => {
	const { t, i18n } = useTranslation();
	const name = i18n.language === 'en' ? 'name_en' : 'name_ru';
    const user = useAppSelector(store => store.auth.user);
    const event = useAppSelector(store => store.event);
    const [ isAboutOpen, setIsAboutOpen ] = useState(false);
    const [ category, setCategory ] = useState<Category|null>(null);

    if(!user) return <div className='error'>{t('common.nouser')}</div>;
    if(!event) return <div className='error'>{t('common.noevent')}</div>;

    return (
		<div className='Search'>
            <LangSwitcher/>
            <SwitchToProfile refSearch={refSearch} refProfile={refProfile}/>
            <h1>{event[name]}</h1>

            <div className='Event'>
                <img className='Logo' alt='logo' src={getFileURL(event.logo)}/>
                <div className='Info'>
                    <div className='Name'>{t('search.title.' + user.role)}</div>
                    {t('search.subtitle')}
                </div>
            </div>

            <CategoryList onChange={setCategory}/>
            <AttendeeList category={category}/>
            
            <hr style={{
                margin: '1rem 0',
                borderTop: '1px solid lightsteelblue',
                borderBottom: 'none',
            }}/>
            
            <p className='center'><span className='Link' onClick={() => setIsAboutOpen(true)}>
                {t('common.about')}
            </span></p>
            <About isOpen={isAboutOpen} onClose={() => setIsAboutOpen(false)}/>
		</div>
	);
};

export default Search;
